import { createTheme } from '@fluentui/react';
import { lightSurfaces } from './surfaces';

export const defaultTheme = createTheme({
    // palette: {
    //  //This space intentionally left blank.
    //  //This will fall back to using the default light theme colors.
    // },
    semanticColors: {
        infoBackground: '#c7e0f4',
        bodyBackground: '#ffffff',
        bodyDivider: '#f3f2f1',
        successBackground: '#dff6dd',
        warningBackground: '#fff4ce',
        errorBackground: '#fde7e9',
    },
});

defaultTheme.surfaces = lightSurfaces;
